export const parsePackageUrl = (url: string) => {
  if (url.startsWith('https://github.com/')) {
    // Check for the use of shorthands
    if (url.includes('#')) {
      let [
        baseUrl,
        // eslint-disable-next-line prefer-const
        ref,
      ] = url.split('#');

      // Remove trailing slash
      if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);

      return { url: baseUrl, ref };
    }
  }

  return { url };
};
